/* BHC — phone-only sticky add-to-cart.
   Mirrors the real product form rather than posting its own request, so
   variant selection, sold-out state and the cart drawer all keep working
   through the existing code path. */
(function () {
  'use strict';

  if (!document.body || (document.body.dataset.template || '').indexOf('product') !== 0) return;

  var MQ = window.matchMedia('(max-width: 749px)');
  var real, bar, btn, priceEl, nameEl, io;

  function build() {
    real = document.querySelector('.bhc-product__atc-btn');
    if (!real || bar) return;

    var title = document.querySelector('.bhc-product__title');
    priceEl = document.querySelector('.bhc-product__price');

    bar = document.createElement('div');
    bar.className = 'bhc-sticky-atc';
    bar.innerHTML =
      '<div class="bhc-sticky-atc__meta">' +
      '<p class="bhc-sticky-atc__name"></p>' +
      '<p class="bhc-sticky-atc__price"></p>' +
      '</div>' +
      '<button type="button" class="bhc-sticky-atc__btn"></button>';

    nameEl = bar.querySelector('.bhc-sticky-atc__name');
    btn = bar.querySelector('.bhc-sticky-atc__btn');
    nameEl.textContent = title ? title.textContent.trim() : '';
    sync();

    btn.addEventListener('click', function () {
      real.click();
    });

    document.body.appendChild(bar);

    io = new IntersectionObserver(function (entries) {
      // Shown only while the real button is off screen.
      show(!entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -10px 0px' });
    io.observe(real);

    // Scroll fallback. The observer is the primary signal; this covers
    // browsers that deliver its first callback late, and costs one cached
    // number per frame rather than a layout read.
    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });

    if (priceEl) {
      new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
    new MutationObserver(sync).observe(real, { attributes: true, attributeFilter: ['disabled', 'class'] });
  }

  var anchorTop = 0, anchorBottom = 0, ticking = false;

  function measure() {
    var r = real.getBoundingClientRect();
    anchorTop = r.top + window.scrollY;
    anchorBottom = anchorTop + r.height;
  }

  function show(on) {
    bar.classList.toggle('is-visible', !!on);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var top = window.scrollY;
      show(anchorBottom < top || anchorTop > top + window.innerHeight);
    });
  }

  function sync() {
    if (!bar) return;
    bar.querySelector('.bhc-sticky-atc__price').textContent = priceEl ? priceEl.textContent.trim() : '';
    var out = real.disabled || /sold\s*out/i.test(real.textContent);
    btn.textContent = out ? 'Sold Out' : 'Add to Cart';
    btn.disabled = !!out;
  }

  function boot() {
    if (MQ.matches) build();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  MQ.addEventListener ? MQ.addEventListener('change', boot) : MQ.addListener(boot);
})();
